import { Link } from '@tanstack/react-router';

import { Button } from '@nesso/ui/primitives/button';

type Props = {
    email: string;
};

export function RequestPasswordResetSent({ email }: Props) {
    return (
        <>
            <div className="flex flex-col gap-2">
                <h1 className="text-3xl font-bold md:text-4xl">Check your email</h1>
                <p className="text-lg font-semibold">Instructions sent to {email}</p>
            </div>

            <p className="text-muted-foreground text-sm">
                Didn&apos;t receive it? Don&apos;t forget to check your spam folder. If no email
                arrives within 2 minutes, email hello@nessoapp.com
            </p>

            <div className="flex flex-col md:items-center">
                <Button
                    asChild
                    variant="ghost"
                    size="sm"
                    className="h-8 w-full md:h-10 md:w-auto md:px-6 md:text-sm"
                >
                    <Link to="/login">Return to Login</Link>
                </Button>
            </div>
        </>
    );
}
